// actionTypes.jsx
export const IS_LOADING_FETCH_SCHEDULE = 'IS_LOADING_FETCH_SCHEDULE';
export const GET_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE = 'GET_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE';
export const FAILURE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE = 'FAILURE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE';
export const UPDATE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE = 'UPDATE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE';